export default __webpack_public_path__ + "static/media/i-generate-spinner-64px-green.f77fabf4.svg";